// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Tj0zu","logo":"logo--b6IEK","title":"title--eli-A","errorMessage":"errorMessage--+T1h+"};